var map = {
	"./en.svg": 11092,
	"./es.svg": 69361,
	"./fr.svg": 12901,
	"./ja.svg": 15706,
	"./ptbr.svg": 77445,
	"./zh.svg": 45443,
	"assets/lang/en.svg": 11092,
	"assets/lang/es.svg": 69361,
	"assets/lang/fr.svg": 12901,
	"assets/lang/ja.svg": 15706,
	"assets/lang/ptbr.svg": 77445,
	"assets/lang/zh.svg": 45443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5243;